import { render } from "./FollowBonusPanel.vue?vue&type=template&id=018581a7&scoped=true"
import script from "./FollowBonusPanel.vue?vue&type=script&lang=js"
export * from "./FollowBonusPanel.vue?vue&type=script&lang=js"

import "./FollowBonusPanel.vue?vue&type=style&index=0&id=018581a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018581a7"]])

export default __exports__